# Create Channel

## Channel Name

This is the descriptive name for your channel.

## Create

To create this channel click <v-btn prepend-icon='mdi-plus' color='primary'>CREATE</v-btn>. To cancel click <v-icon>mdi-close-circle</v-icon> (top right).
